import PaperSetup from 'home/PaperSetup';
import ThreeSetup from 'home/ThreeSetup';
import * as TweenMax from 'gsap/umd/TweenMax';

export default class HomeAnimation {

    init(sectionColor, duration = 0.75, delay = 0.3) {

        this.pathColors = {
            elektro: 3,
            auto: 6,
            garten: 4,
            holz: 2,
            betriebsunterhalt: 7,
            bau: 5,
            allgemein: 8,
            home: 1,
            meta: 0,
        };

        this.initState = this.pathColors[sectionColor];
        this.pixelRatio = window.devicePixelRatio ? window.devicePixelRatio : 1;
        // this.pixelRatio = 1;

        this.moveX = 0;
        this.moveY = 0;
        this.lastMoveX = 0;
        this.lastMoveY = 0;
        this.smoothMoveX = 0;
        this.smoothMoveY = 0;

        this.prevX = 0;
        this.prevY = 0;

        this.tranFirstTimeout = setTimeout(() => {}, 0);

        this.initDom();
        this.initCanvas(duration, delay);
        this.initListeners();
    }

    initDom() {
        this.container = document.createElement('div');
        this.svgCcontainer = document.createElement('div');
        this.svgCcontainer.classList.add('svgContainer');

        this.triangle = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        this.svgNS = this.triangle.namespaceURI;
        this.triangle.setAttribute('width', '100%');
        this.triangle.setAttribute('height', '100%');
        this.triangle.setAttribute('height', '100%');
        this.triangle.setAttribute('viewBox', '0 0 100 100');
        this.triangle.setAttribute('fill', '#1A9FDD');
        this.triangle.setAttribute('stroke-width', '0');
        this.polygon = document.createElementNS(this.svgNS, 'polygon');
        this.polygon.setAttribute('points', '0,0 100,100 0,100');
        this.triangle.appendChild(this.polygon);


        this.paperCanvas = document.createElement('canvas');
        this.paperCanvas.classList.add('paperCanvas');
        this.paperCanvas.dataset.paperResize = false;
        this.paperCanvas.dataset.paperHidpi = 'off';

        this.threeCanvas = document.createElement('canvas');
        this.threeCanvas.classList.add('threeCanvas');

        this.container.classList.add('canvasContainers');
        this.container.appendChild(this.paperCanvas);
        this.container.appendChild(this.threeCanvas);
        this.svgCcontainer.appendChild(this.triangle);
        this.container.appendChild(this.svgCcontainer);


        document.body.appendChild(this.container);

        this.width = this.threeCanvas.clientWidth;
        this.height = this.threeCanvas.clientHeight;
    }

    initCanvas(duration, delay) {
        this.threeSetup = new ThreeSetup(this.width, this.height, this.pixelRatio);
        this.threeSetup.init(this.threeCanvas, this.paperCanvas);

        this.paperSetup = new PaperSetup();
        this.paperSetup.init(this.initState, this.paperCanvas, this.threeCanvas, this.triangle, this.threeSetup, duration, delay);

        // this.paperSetup.getUpdate(this.threeSetup);
    }

    initListeners() {
        this.onMouseMoveFunc = this.onMouseMove.bind(this);
        this.onTouchMoveFunc = this.onTouchMove.bind(this);
        this.onTouchEndFunc = this.onTouchEnd.bind(this);
        this.animateFunc = this.animate.bind(this);
        this.onWindowResizeFunc = this.onWindowResize.bind(this);

        this.threeCanvas.addEventListener('mousemove', this.onMouseMoveFunc, false);
        this.threeCanvas.addEventListener('touchstart', this.onTouchMoveFunc, false);
        this.threeCanvas.addEventListener('touchend', this.onTouchEndFunc, false);
        this.threeCanvas.addEventListener('touchmove', this.onTouchMoveFunc, false);
        TweenMax.ticker.addEventListener('tick', this.animateFunc);
        window.addEventListener('resize', this.onWindowResizeFunc, false);
    }

    triangleIntro() {
        this.paperSetup.triangleIntro();
    }

    animate() {
        this.threeSetup.animate();
        this.smoothMove();
        this.threeSetup.smoothMove(this.smoothMoveX, this.smoothMoveY);
    }

    transition(sectionColor, duration = 1, delay = 0) {
        this.paperSetup.transition(this.pathColors[sectionColor], duration, delay);
    }


    onWindowResize() {
        this.width = this.threeCanvas.clientWidth;
        this.height = this.threeCanvas.clientHeight;

        this.threeSetup.onWindowResize(this.width, this.height);
        this.paperSetup.onWindowResize();
    }

    onMouseMove(e) {
        this.mouseX = e.offsetX;
        this.mouseY = e.offsetY;

        const movementX = this.prevX ? e.screenX - this.prevX : 0;
        const movementY = this.prevY ? e.screenY - this.prevY : 0;

        this.prevX = e.screenX;
        this.prevY = e.screenY;

        this.moveX = e.movementX || movementX;
        this.moveY = e.movementY || movementY;

        this.threeSetup.onMouseMove(this.mouseX, this.mouseY);
    }

    onTouchEnd(e) {
        this.paperSetup.transition(Math.floor(Math.random() * Object.keys(this.pathColors).length), 1, 0);
        this.transitionFirst();
    }

    onTouchMove(e) {
        e.preventDefault();

        const rect = e.touches[0].target.getBoundingClientRect();

        this.mouseX = e.touches[0].pageX - rect.left;
        this.mouseY = e.touches[0].pageY - rect.top;

        this.moveX = this.mouseX - this.lastMoveX;
        this.moveY = this.mouseY - this.lastMoveY;

        // console.log(this.moveX, this.moveY);

        this.lastMoveX = this.mouseX;
        this.lastMoveY = this.mouseY;

        this.threeSetup.onMouseMove(this.mouseX, this.mouseY);
    }

    smoothMove() {
        this.moveX = Math.abs(this.moveX);
        this.moveY = Math.abs(this.moveY);

        this.moveX -= 0.5;
        this.moveY -= 0.5;

        this.moveX = Math.max(0, this.moveX);
        this.moveY = Math.max(0, this.moveY);

        this.moveX = Math.min(15, this.moveX);
        this.moveY = Math.min(15, this.moveY);

        const targetX = this.moveX;
        const dx = targetX - this.smoothMoveX;
        this.smoothMoveX += dx * 0.1;

        const targetY = this.moveY;
        const dy = targetY - this.smoothMoveY;
        this.smoothMoveY += dy * 0.1;
    }

    transitionFirst(duration = 1, delay = 1) {
        clearTimeout(this.tranFirstTimeout);
        this.tranFirstTimeout = setTimeout(() => {
            this.paperSetup.transitionFirst(duration);
        }, delay * 1000);
    }

    destroy() {
        // this.paperSetup.destroy(duration, delay, () => {
        this.threeCanvas.removeEventListener('mousemove', this.onMouseMoveFunc, false);
        this.threeCanvas.removeEventListener('touchstart', this.onTouchMoveFunc, false);
        this.threeCanvas.removeEventListener('touchmove', this.onTouchMoveFunc, false);
        TweenMax.ticker.removeEventListener('tick', this.animateFunc);
        window.removeEventListener('resize', this.onWindowResizeFunc, false);
        this.container.remove();
        // });
    }
}
